<template>
  <div class="upload-container">
    <el-button
      :style="{ background: color, borderColor: color }"
      icon="el-icon-upload"
      size="mini"
      type="primary"
      @click="dialogVisible = true"
      >上传图片</el-button
    >
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <el-upload
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        class="editor-slide-upload"
        :action="getputhimg()"
        list-type="picture-card"
        :headers="headers"
        name="uploadFile"
        :data="{
          asImage: true,
          fieldName: 'headImageUrl',
          model: '',
        }"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils";
import projectConfig from "@/core/config";
export default {
  name: "EditorSlideUpload",
  props: {
    color: {
      type: String,
      default: "#1890ff",
    },
    editorType: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: [],
      url: [],
      headers: { Authorization: getToken() },
      showImageUrl: projectConfig.imageBaseUrl, //显示图片路径
    };
  },
  methods: {
    getputhimg() {
      switch (this.editorType) {
        case "0":
          //标准ERP后台
          return projectConfig.baseUrl + "qingguang/tenantbussiness/common/upload";
        case "1":
          //运维后台
          return "";

        default:
          break;
      }
    },
    checkAllSuccess() {
      return Object.keys(this.listObj).every((item) => this.listObj[item].hasSuccess);
    },
    handleSubmit() {
      if (this.url == []) {
        this.$message("请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！");
        return;
      }
      this.$emit("successCBK", this.url);
      this.listObj = {};
      this.fileList = [];
      this.url = [];
      this.dialogVisible = false;
    },
    handleSuccess(res) {
      this.url.push(this.showImageUrl + res.data.uploadPath + res.data.filename);
    },
    handleRemove(file, filelist) {
      this.url = [];
      filelist.forEach((item) => {
        if (item.response) {
          this.url.push(
            this.showImageUrl +
              item.response.data.uploadPath +
              item.response.data.filename
          );
        } else {
          this.url.push(item);
        }
      });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  // /deep/ .el-upload--picture-card {
  //   width: 100%;
  // }
}
</style>
